import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_FORM = gql`
  mutation upsertWorkspaceForm($input: UpsertWorkspaceFormInput!) {
    workspaceForm: upsertWorkspaceForm(input: $input) {
      id
      name
      version
      published
      webCollection
      url
      users {
        id
        user {
          id
        }
      }
      respondents {
        id
        user {
          id
        }
      }
      dueDates {
        id
        periodDate
      }
    }
  }
`;
